import { reduce } from 'lodash-es';

/**
 * Initialize Questions
 * @param {*} questions
 */
export const initializeQuestionsFormik = ({ documents, contracts }) => {
  try {
    // TODO
    const result = {
      ...reduce(
        contracts,
        (item, val) => {
          item[val.id] = val.component;
          return item;
        },
        {}
      ),
      ...reduce(
        documents,
        (item, val) => {
          item[val.code] = val.value;
          return item;
        },
        {}
      ),
    };

    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`initializeQuestionsFormik: ${e.stack}`);
  }
  return [];
};
